
import { mapGetters } from 'vuex'
export default {
	props: {
		filter: {
			type: Object,
			requried: true
		},
		filterSearchPropertyIds: {
			type: Object,
			requried: true
		},
		gameId: {
			type: Number,
			requried: true
		}
	},
	data() {
		return {
			searchList: []
		}
	},
    computed: {
		...mapGetters({
			indexGameFilter: 'game/indexGameFilter'
		})
	},
	methods: {
		onUpdated(field,item) {
			this.$emit('update:filter', { ...this.filter, [field]: this.filter[field] ? undefined : true })
			this.$emit('search',item)
		},
		async getList() {
			let data = {
				action: {
					gameId: this.gameId
				}
			}
			let res = await this.$api.postGoodsPublicSearchProperties(data)
			if (!res.success) return this.$message.error(res.info)
			this.searchList = res.data
		},

		onSelectItem(item) {
			const _filter = JSON.parse(JSON.stringify(this.filter))
			const _filterKeywords = JSON.parse(JSON.stringify(this.filterSearchPropertyIds))
			if (!_filterKeywords[item.id]) {
				_filterKeywords[item.id] = [item.id]
			} else {
				const index = _filterKeywords[item.id].indexOf(item.id)
				if (index === -1) {
					_filterKeywords[item.id].push(item.id)
				} else {
					_filterKeywords[item.id].splice(index, 1)
				}
			}
			this.$emit('update:filter', _filter)
			this.$emit('update:filterSearchPropertyIds', _filterKeywords)
			this.$emit('search',item)
		}
	},
	mounted() {
		this.getList()
        if (this.indexGameFilter?.id) {
			if (this.indexGameFilter.propertyType === 'FIELD') {
				this.$emit('update:filter', { [this.indexGameFilter.searchField]: true })
			} else {
				this.$emit('update:filterSearchPropertyIds', { [this.indexGameFilter.id]: [this.indexGameFilter.id] })
			}
			this.$store.commit('game/SET_INDEX_GAME_FILTER', {})
			this.$emit('search')
		}
	}
}
